"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = Header;
const jquery_1 = __importDefault(require("jquery"));
const UnityComm_1 = require("../utils/UnityComm");
function Header() {
    // Create the header HTML with instructions and controls
    let header = (0, jquery_1.default)("#header");
    if (header.length === 0) {
        header = (0, jquery_1.default)(`
            <div id="header">
                <button id="reset-scene-button">Reset Scene</button>
                <!-- Add more header content here if needed -->
            </div>
        `);
        (0, jquery_1.default)("body").prepend(header);
    }
    (0, jquery_1.default)("#reset-scene-button").on("click", function () {
        (0, UnityComm_1.UnityResetScene)();
        // Close all jQuery UI dialogs
        (0, jquery_1.default)(".ui-dialog-content").dialog("close");
    });
    (0, jquery_1.default)(document).tooltip();
}
